import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import CoursesService from '@/services/CoursesService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        availableFrom: null,
        availableUntil: null,
        editorNote: null,
        sortOrder: null,
        userNote: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        availableFrom: state.availableFrom,
        availableUntil: state.availableUntil,
        editorNote: state.editorNote,
        sortOrder: state.sortOrder,
        userNote: state.userNote,
        status: state.status,
    }),
};

const mutations = {
    setLecturesLearningTrack(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadLecturesLearningTrack({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await CoursesService.getCourseLearningTracks(course.id, {
            EntityId: data.id
        });
        commit('setLecturesLearningTrack', res.data.items[0]);
        return res.data;
    },
    async loadLecturesLearningTrackAdmin({ commit }, data) {
        const res = await CoursesService.getReportAdmin(data.id);
        commit('setLecturesLearningTrack', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
